export default function PremiumMode(premiumMode) {
    switch (premiumMode) {
        case "Single Pay":
            return 1;

        case '2 Pay':
            return 2;

        case '3 Pay':
            return 3;

        case '4 Pay':
            return 4;

        case '5 Pay':
            return 5;

        case '7 Pay':
            return 7;

        case '10 Pay':
            return 10;

        case '15 Pay':
            return 15;

        case '20 Pay':
            return 20;

        default:
            return 1;
    }
}


// WEBPACK FOOTER //
// ./src/components/Product/SharedComponents/YourInformation/PremiumMode.js